import React from 'react';
import { Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { 
  FaPlus, 
  FaCalendarCheck, 
  FaUser, 
  FaFileAlt,
  FaBolt
} from 'react-icons/fa';

const EmployeeQuickActions = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 'apply-leave',
      label: 'Apply for Leave',
      icon: <FaPlus />,
      color: 'primary',
      path: '/leaves',
      description: 'Submit a new leave request'
    },
    {
      id: 'view-attendance',
      label: 'View Attendance',
      icon: <FaCalendarCheck />,
      color: 'success',
      path: '/attendance',
      description: 'Check your attendance history'
    },
    {
      id: 'my-profile',
      label: 'My Profile',
      icon: <FaUser />,
      color: 'info',
      path: '/my-profile',
      description: 'View and edit your profile'
    },
    {
      id: 'my-leaves',
      label: 'My Leaves',
      icon: <FaFileAlt />,
      color: 'warning',
      path: '/leaves',
      description: 'View all leave requests'
    }
  ];

  const handleAction = (path) => {
    navigate(path);
  };

  return (
    <Card className="border-0 shadow-sm employee-quick-actions">
      <Card.Header className="bg-white border-0 py-3">
        <h5 className="mb-0 fw-bold">
          <FaBolt className="me-2 text-warning" />
          Quick Actions
        </h5>
      </Card.Header>
      <Card.Body>
        <div className="quick-actions-list">
          {quickActions.map((action) => (
            <Button
              key={action.id}
              variant={`outline-${action.color}`}
              className="quick-action-btn w-100 mb-2 text-start d-flex align-items-center py-2 px-3 border-0 bg-light bg-opacity-10"
              onClick={() => handleAction(action.path)}
            >
              <span className="action-icon me-3">{action.icon}</span>
              <span className="action-label fw-bold">{action.label}</span>
            </Button>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default EmployeeQuickActions;
